// src/components/ProductList.js
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "../axiosConfig";
import ProductForm from "./ProductForm";
import Sidebar from "./Sidebar";

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [isProductFormOpen, setIsProductFormOpen] = useState(false);

  const fetchProducts = async () => {
    try {
      const response = await axios.get("/store/products");
      setProducts(response.data.products);
    } catch (err) {
      console.error("Failed to fetch products", err);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const handleAddProduct = async () => {
    setIsProductFormOpen(false);
    fetchProducts();
  };

  const handleAddProductClick = () => {
    setIsProductFormOpen(true);
  };

  const handleCloseProductForm = () => {
    setIsProductFormOpen(false);
  };

  const handleRefreshClick = () => {
    fetchProducts();
  };

  return (
    <Container>
      <Sidebar />
      <Content>
        <Header>
          <Title>Produtos</Title>
          <ButtonContainer>
            <AddProductButton onClick={handleAddProductClick}>
              Adicionar Novo Produto
            </AddProductButton>
            <RefreshButton onClick={handleRefreshClick}>Refresh</RefreshButton>
          </ButtonContainer>
        </Header>
        <ProductListContainer>
          {products.map((product) => (
            <ProductItem key={product.id}>
              <ProductName>{product.product_title}</ProductName>
              <ProductPrice>R$ {product.store_product_price}</ProductPrice>
              <ProductDescription>
                {product.product_description.length > 100
                  ? `${product.product_description.substring(0, 100)}...`
                  : product.product_description}
              </ProductDescription>
            </ProductItem>
          ))}
        </ProductListContainer>
      </Content>
      {isProductFormOpen && (
        <ProductFormContainer>
          <ProductForm
            onProductAdded={handleAddProduct}
            onClose={handleCloseProductForm}
          />
        </ProductFormContainer>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
  @media screen and (max-width: 600px) {
   flex-direction: column;
  }
`;

const Content = styled.div`
  flex: 1;
  padding: 20px;
  overflow-y: auto;
`;

const ProductFormContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
  padding: 20px;
  border-left: 1px solid #ddd;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const Title = styled.h2`
  margin: 0;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const AddProductButton = styled.button`
  padding: 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #45a049;
  }
`;

const RefreshButton = styled.button`
  padding: 10px;
  background-color: #2196f3;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #1976d2;
  }
`;

const ProductListContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ProductItem = styled.div`
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  margin-bottom: 10px;
`;

const ProductName = styled.div`
  font-weight: bold;
`;

const ProductPrice = styled.div`
  color: #888;
`;

const ProductDescription = styled.div`
  color: #555;
`;

export default ProductList;
